import { api } from './api.js';
import { TAG_ADMIN_TICKET, TAG_LIST_ADMIN_TICKETS, TAG_LIST_USER_TICKETS, TAG_USER_TICKET } from './tags.js';

export const ticketsEndpoints = api.injectEndpoints({
    endpoints: (builder) => ({
        getTicketTypes: builder.query({
            query: () => ({
                url: '/misc/support-ticket-types',
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getTicketStatuses: builder.query({
            query: () => ({
                url: '/misc/support-ticket-statuses',
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getTicketUsers: builder.query({
            query: () => ({
                url: '/misc/support-ticket-users',
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        addTicket: builder.mutation({
            query: (data) => ({
                url: '/tickets/add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: [TAG_LIST_USER_TICKETS, TAG_LIST_ADMIN_TICKETS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getMyTickets: builder.query({
            query: ({ type, status }) => {
                const queryParams = new URLSearchParams();
                if (type) queryParams.append('type', type);
                if (status) queryParams.append('status', status);

                return {
                    url: `/tickets/my-tickets?${queryParams.toString()}`,
                    method: 'GET'
                };
            },
            providesTags: [TAG_LIST_USER_TICKETS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getMyTicket: builder.query({
            query: (id) => ({
                url: `/tickets/my-ticket/${id}`,
                method: 'GET'
            }),
            providesTags: [TAG_USER_TICKET],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        addTicketMessage: builder.mutation({
            query: ({ id, data }) => ({
                url: `/tickets/my-ticket/${id}`,
                method: 'POST',
                body: data,
                toast: false
            }),
            invalidatesTags: [TAG_USER_TICKET, TAG_LIST_USER_TICKETS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getAdminTickets: builder.query({
            query: ({ type, status, user }) => {
                const queryParams = new URLSearchParams();
                if (type) queryParams.append('type', type);
                if (status) queryParams.append('status', status);
                if (user) queryParams.append('user', user);

                return {
                    url: `/tickets/list?${queryParams.toString()}`,
                    method: 'GET'
                };
            },
            providesTags: [TAG_LIST_ADMIN_TICKETS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getAdminTicket: builder.query({
            query: (id) => ({
                url: `/tickets/view/${id}`,
                method: 'GET'
            }),
            providesTags: [TAG_ADMIN_TICKET],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        addAdminTicketMessage: builder.mutation({
            query: ({ id, data }) => ({
                url: `/tickets/edit/${id}`,
                method: 'POST',
                body: data,
                toast: false
            }),
            invalidatesTags: [TAG_ADMIN_TICKET, TAG_LIST_ADMIN_TICKETS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        deleteTicket: builder.mutation({
            query: (id) => ({
                url: `/tickets/delete/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: [TAG_LIST_USER_TICKETS, TAG_LIST_ADMIN_TICKETS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        })
    })
});

export const {
    useGetTicketTypesQuery,
    useGetTicketStatusesQuery,
    useGetTicketUsersQuery,
    useAddTicketMutation,
    useGetMyTicketsQuery,
    useGetMyTicketQuery,
    useAddTicketMessageMutation,
    useGetAdminTicketsQuery,
    useGetAdminTicketQuery,
    useAddAdminTicketMessageMutation,
    useDeleteTicketMutation
} = ticketsEndpoints;
